import React from "react";
import { List } from "lucide-react";
import SearchScreenerHeading from "./SearchScreenerHeading";
import SearchResultsMainContent from "./SearchResultsMainContent";
import SearchSummaryBanner from "./SearchSummaryBanner";
import MapResultCard from "./MapResultCard";

function openSearchFilters() {
  window.dispatchEvent(new CustomEvent("openSearchFilters"));
}

function SearchResultsWorkspace({
  activeView,
  onViewChange,
  responseId,
  screenerToken,
  surveyName,
  category,
  relatedTerms,
  onRelatedSearch,
  loading,
  results,
  totalResults,
  currentPage,
  lastPage,
  perPage,
  searchCoords,
  selectedResultId,
  onSelectResult,
  onIndicateResult,
  onRestoreResult,
  onClearSelectedResult,
  savedResourceIds,
  hasSearchTerms,
  onResourceSaved,
  pageNum,
  onPageChange,
}) {
  const showListView = activeView === "list";
  const selectedMapResult = results.find((result) => result.program_site_id === selectedResultId);

  return (
    <div className={`search-results-workspace${showListView ? "" : " search-results-workspace--map"}`}>
      <div className="search-results-workspace-header">
        <SearchScreenerHeading
          responseId={responseId}
          screenerToken={screenerToken}
          surveyName={surveyName}
          category={category}
        />
      </div>

      {!showListView && <SearchSummaryBanner onEdit={openSearchFilters} />}

      <div className="search-results-workspace-body">
        <div
          className={`search-results-workspace-panel${showListView ? " active" : ""}`}
          role="tabpanel"
          aria-hidden={!showListView}
        >
          <SearchResultsMainContent
            relatedTerms={relatedTerms}
            onRelatedSearch={onRelatedSearch}
            loading={loading}
            results={results}
            totalResults={totalResults}
            currentPage={currentPage}
            lastPage={lastPage}
            perPage={perPage}
            searchCoords={searchCoords}
            selectedResultId={selectedResultId}
            onSelectResult={onSelectResult}
            onIndicateResult={onIndicateResult}
            onRestoreResult={onRestoreResult}
            responseId={responseId}
            surveyName={surveyName}
            savedResourceIds={savedResourceIds}
            hasSearchTerms={hasSearchTerms}
            onResourceSaved={onResourceSaved}
            pageNum={pageNum}
            onPageChange={onPageChange}
            onViewMap={() => onViewChange("map")}
          />
        </div>
        <div
          className={`search-results-workspace-panel search-results-map-panel${!showListView ? " active" : ""}`}
          role="tabpanel"
          aria-hidden={showListView}
        >
          <div className="search-results-map-host" />
          {!showListView && selectedMapResult && (
            <MapResultCard
              result={selectedMapResult}
              searchCoords={searchCoords}
              onClose={onClearSelectedResult}
              onSelect={onSelectResult}
            />
          )}
          {!showListView && (
            <button
              className="search-results-view-list-pill"
              type="button"
              onClick={() => onViewChange("list")}
            >
              <List aria-hidden="true" size={16} strokeWidth={1.8} />
              <span>View list</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchResultsWorkspace;
